import { defineComponent as a, onBeforeMount as m, createBlock as i, openBlock as y, unref as o, normalizeClass as c, withCtx as t, createVNode as n } from "vue";
import { Dialog as f, DialogPanel as u } from "@headlessui/vue";
import { addScalarClassesToHeadless as C } from "@scalar/components";
import { DocumentClasses as d } from "../../styles.js";
import h from "./Overlay.vue.js";
import S from "./TypesenseSearch.vue.js";
const g = /* @__PURE__ */ a({
  __name: "Search",
  props: {
    showSearch: { type: Boolean },
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  emits: ["close"],
  setup(H, { emit: r }) {
    const l = r;
    return m(() => C()), (e, s) => (y(), i(o(f), {
      class: c(o(d).Search),
      open: e.showSearch,
      onClose: s[1] || (s[1] = (p) => l("close"))
    }, {
      default: t(() => [
        n(h, null, {
          default: t(() => [
            n(o(u), { class: "document-search-container" }, {
              default: t(() => [
                n(S, {
                  typesenseCollection: e.typesenseCollection,
                  typesenseHost: e.typesenseHost,
                  typesenseKey: e.typesenseKey,
                  onClose: s[0] || (s[0] = (p) => l("close"))
                }, null, 8, ["typesenseCollection", "typesenseHost", "typesenseKey"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "open"]));
  }
});
export {
  g as default
};
